import { render } from "./change-passwords.vue?vue&type=template&id=7470d5e0"
import script from "./change-passwords.vue?vue&type=script&lang=js"
export * from "./change-passwords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__